import React from 'react';
import { moments, needs } from '../data/content';
const needColor = (label: string) => needs.find(need => need.label === label)?.color ?? '#d8b35a';
export function UseMoments() {
  return <section className="bg-night" data-id="element-188" data-mp="2ty72p7xrkj6">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-189" data-mp="2uztfpuejtg7">
        <div className="mx-auto max-w-2xl text-center" data-id="element-190" data-mp="3uz1z05uzcusj">
          <h2 className="font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-191" data-mp="3v0mxu7obuzw7">
            Momentos para abrir tu Botiquín
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/70" data-id="element-192" data-mp="qm59o6498nr1">
            Situaciones de todos los días en las que una Palabra de Dios hace la diferencia.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-5xl gap-x-10 border-t border-night-line md:grid-cols-2" data-id="element-193" data-mp="hpnt2nd4fxnw">
          {moments.map(moment => <li key={moment.title} className="border-b border-night-line py-6" data-id="element-194" data-mp="19io9g4t64zax">
              <span className="inline-flex items-center gap-2 font-sans text-xs font-semibold text-parchment/60" data-id="element-195" data-mp="1pvefd5rfphe5">
                <span aria-hidden="true" className="h-2 w-2 rounded-full" style={{
              backgroundColor: needColor(moment.need)
            }} data-id="element-196" data-mp="1uuh6dmakxn34" />
                {moment.need}
              </span>
              <h3 className="mt-2 font-display text-xl font-semibold leading-snug text-parchment" data-id="element-197" data-mp="1l2bgci3w1fqk">
                {moment.title}
              </h3>
              <p className="mt-1.5 font-sans text-[0.95rem] leading-relaxed text-parchment/70" data-id="element-198" data-mp="1c3zu0sa2143x">
                {moment.description}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}